import { render } from "./star.vue?vue&type=template&id=0e587007&scoped=true"
import script from "./star.vue?vue&type=script&lang=js"
export * from "./star.vue?vue&type=script&lang=js"

import "./star.vue?vue&type=style&index=0&id=0e587007&scoped=true&lang=css"

import exportComponent from "/Users/alvinpascasio/pjf-wine-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e587007"]])

export default __exports__